"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider } from "./color-mode";
import { system } from "../theme.ts";

export function Provider(props) {
  return (
    <ChakraProvider value={system} resetCSS>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
